import React, { useContext } from 'react'
import { ReducerDispatchContext, ReducerContext } from '../reducers/reducerContext.js';
import { resetPosts, reInitPostsUnauthorised } from '../actions/actionsAppTest'
import WaitSetting from '../components/setting/WaitSetting'

export default function ContWaitSetting() {

  const dispatch = useContext(ReducerDispatchContext);
  const globalstate = useContext(ReducerContext);

  function onStopWaiting() {
    dispatch(resetPosts())
  }
  function onResetUnauthorised() {
    dispatch(reInitPostsUnauthorised())
  }

  return (
    <WaitSetting
      settings={globalstate.settings}
      context={globalstate.testCriteria.context}
      vehicle={globalstate.testCriteria.vehicle}
      parameters={globalstate.testCriteria.parameters}
      responseSimulation={globalstate.responseSimulation}
      posts={globalstate.posts}
      env={globalstate.env}
      onStopWaiting={onStopWaiting}
      onResetUnauthorised={onResetUnauthorised}
    />
  );
}
